import { useNavigate } from "react-router-dom";
import { useDeleteStudent } from "../../../../hooks/school/student/useDeleteStudent";
import { POPUP_CLOSE_TIME } from "../../../../constant/constant";
import { useState } from "react";
import DeleteModal from "../../../common/DeleteModal";
import "../../SuperAdmin/toggle.css";

/**
 * @typedef {import("../../../../hooks/teacher/students/useGetStudentsByTeacher").StudentResponseItem} StudentResponseItem
 */

/**
 * 
 * @param {{student: StudentResponseItem, refetch: () => void, disabled: boolean, onToggle: Function, toggleLoading: boolean, toggleError: string, toggleSuccess: boolean, resetToggleState: Function, onToggleSuccess: Function}} param
 */

const StudentTableRow = ({
    student,
    refetch,
    disabled,
    onToggle,
    toggleLoading,
    toggleError,
    toggleSuccess,
    resetToggleState,
    onToggleSuccess,
}) => {
    const navigate = useNavigate();
    const [deleteModal, setDeleteModal] = useState(false);
    const [showToggleModal, setShowToggleModal] = useState(false);
    const [isToggling, setIsToggling] = useState(false);
    const { deleteStudent, loading, error, success } = useDeleteStudent()

    const isActive = student?.status === "1" || student?.status === 1;

    const handleDeleteModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDeleteModal(!deleteModal);
    };
    const handleDelete = async () => {
        await deleteStudent(student.id, () => {
            setTimeout(() => {
                setDeleteModal(false);
                refetch();
            }, POPUP_CLOSE_TIME);
        });
    };

    // Toggle handlers
    const handleToggleShow = (e) => {
        e.preventDefault();
        e.stopPropagation();
        resetToggleState();
        setIsToggling(true);
        setShowToggleModal(true);
    };

    const handleToggleClose = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        resetToggleState();
        setShowToggleModal(false);
        setIsToggling(false);
    };

    const handleToggle = async () => {
        await onToggle(student.id);
    };

    const handleToggleSuccessContinue = () => {
        setShowToggleModal(false);
        setIsToggling(false);
        resetToggleState();
        onToggleSuccess();
    };

    const showToggleLoading = isToggling && toggleLoading;
    const showToggleError = isToggling && toggleError;
    const showToggleSuccess = isToggling && toggleSuccess;

    return (
        <>
            <tr
                key={student.id}
                style={{
                    cursor: "pointer",
                }}
                onClick={() => navigate(`/teacher/student/${student.id}`)}
            >
                <td className="custom-id">{student?.username || "N/A"}</td>
                <td>
                    <div className="custom-name-cell">
                        <span className="custom-name">{student.name}</span>
                    </div>
                </td>
                <td>{student.email}</td>
                <td>
                    <div className="toggle-switch" onClick={(e) => e.stopPropagation()}>
                        <input
                            type="checkbox"
                            id={`teacher-switch-${student.id}`}
                            checked={isActive}
                            onChange={handleToggleShow}
                        />
                        <label
                            htmlFor={`teacher-switch-${student.id}`}
                            className="slider"
                            style={{
                                backgroundColor: isActive ? "#008EF4" : "",
                            }}
                        ></label>
                    </div>
                </td>
                <td className="d-flex gap-2">
                    <button
                        className=""
                        disabled={disabled}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigate(`/teacher/student/update/${student.id}`)
                        }}
                        style={{
                            backgroundColor: "black",
                            color: "white",
                            border: "none",
                            padding: "5px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            whiteSpace: "nowrap",

                        }}
                    >
                        Edit
                    </button>
                    <button className="action-delete-edit-btn" onClick={handleDeleteModal} disabled={disabled}>
                        <i className="bi bi-trash"></i>
                    </button>
                </td>

            </tr>
            <DeleteModal
                message="Are you sure you want to delete this student?"
                showModal={deleteModal}
                handleClose={handleDeleteModal}
                handleDelete={handleDelete}
                loading={loading}
                errorMessage={error}
                successMessage="Student deleted successfully"
                success={success}
            />
            <DeleteModal
                showModal={showToggleModal}
                handleClose={handleToggleClose}
                handleDelete={handleToggle}
                message={`Are you sure you want to ${isActive ? "deactivate" : "activate"} ${student?.name || "this student"}?`}
                loading={showToggleLoading}
                error={showToggleError ? toggleError : ""}
                success={showToggleSuccess}
                successMessage={`${student?.name || "Student"} has been ${isActive ? "deactivated" : "activated"} successfully.`}
                onSuccessContinue={handleToggleSuccessContinue}
                customSuccessTitle={isActive ? "Deactivated Successfully" : "Activated Successfully"}
                customErrorTitle="Toggle Failed"
                customConfirmTitle="Confirm Status Change"
                customActionButtonText={isActive ? "Deactivate" : "Activate"}
                customLoadingButtonText={isActive ? "Deactivating..." : "Activating..."}
            />
        </>
    );
};

export default StudentTableRow;

